import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import Country from "../pages/Manager/Countries/Countries";
import SpecialistDashboard from "../pages/Manager/Dashboard/ManagerDashboard";
import Inquiries from "../pages/Manager/Inquiries/Inquiries";
import ViewInquiry from "../pages/Manager/Inquiries/ViewInquiry/ViewInquiry";
import Make from "../pages/Manager/Makes/Makes";
import Model from "../pages/Manager/Models/Models";
import Options from "../pages/Manager/Options/Options";
import Profile from "../pages/Manager/Profile/Profile";
import EditQuickInvoice from "../pages/Manager/QuickInvoices/EditQuickInvoice/EditQuickInvoice";
import QuickInvoice from "../pages/Manager/QuickInvoices/QuickInvoice/QuickInvoice";
import QuickInvoices from "../pages/Manager/QuickInvoices/QuickInvoices";
import Vehicle from "../pages/Manager/Vehicle/Vehicle";
import VehicleEdit from "../pages/Manager/Vehicles/VehicleEdit/VehicleEdit";
import Vehicles from "../pages/Manager/Vehicles/Vehicles";

var ManagerRoutes = [
  {
    path: "dashboard",
    name: "Dashboard",
    element: <SpecialistDashboard />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  }, 
  {
    path: "quick-invoices",
    name: "Quick Invoices",
    element: <QuickInvoices />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicle",
    name: "Vehicle",
    element: <Vehicle />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicles",
    name: "Vehicles",
    element: <Vehicles />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  }, 
  {
    path: "options",
    name: "Options",
    element: <Options />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicles/:id",
    name: "Vehicle Edit",
    element: <VehicleEdit />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "profile",
    name: "Profile",
    element: <Profile />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "quick-invoices/create-quick-invoice",
    name: "Quick Invoice",
    element: <QuickInvoice />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options/countries",
    name: "Countries",
    element: <Country />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options/makes",
    name: "Makes",
    element: <Make />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options/models",
    name: "Models",
    element: <Model />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "quick-invoices/:id",
    name: "Edit Quick Invoice",
    element: <EditQuickInvoice />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default ManagerRoutes;
